import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';

export interface INote extends IBaseEntity {
    id?: number;
    note?: any;
    noteDateTime?: number;
}
export class Note extends BaseEntity implements INote {
    public id?: number;
    public note?: any;
    public noteDateTime?: number;

    constructor(note?) {
        super();
        if (note) {
            this.id = note.id;
            this.note = note.note;
            this.noteDateTime = note.noteDateTime;
        }
    }

    get discriminator(): any {
        return this.note;
    }

    clone(): Note {
        return new Note(this);
    }
}
